import React, { useEffect, useState } from 'react';
import { Button, Form, Input, notification, Pagination, Popconfirm, Select, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { ColumnsType } from 'antd/lib/table';

import { useAppDispatch, useAppSelector } from 'app/store';
import {
  useEmployeeBlockingMutation,
  useEmployeePasswordResetMutation,
  useLazyGetEmployeesLikeQuery,
} from 'app/services/edpApiV1/employees';
import { useDivisionsQuery, ViewerDivisionsResponse } from 'app/services/edpApiV1/viewer';
import { uiModel } from 'entities/ui';
import { viewerModel } from 'entities/viewer';
import { dataTableForEmployees } from 'shared/helpers/utils';
import { DataEmployees } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { useScrollUpPage } from 'shared/hooks';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { AddEmployeeModal } from '../addAdmin';
import style from './index.module.scss';

const { Search } = Input;

const initialValues = {
  selectOptions: 'search',
};

const Employees = () => {
  const [allDivisions, setAllDivisions] = useState<ViewerDivisionsResponse>();
  const [employees, setEmployees] = useState<DataEmployees[]>();
  const [isEditingModalOpen, setIsEditingModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [optionsSearch, setOptionsSearch] = useState<string>('search');
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [resetPasswordTrigger, passwordResetStatus] = useEmployeePasswordResetMutation();
  const [blockingTrigger, blockingResult] = useEmployeeBlockingMutation();
  const { data: divisions } = useDivisionsQuery(null);
  const [getEmployees, result] = useLazyGetEmployeesLikeQuery();

  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const storeEmployees = useAppSelector(uiModel.Employees.selectors.selectEmployees);
  const currentOrganizationid = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);

  const {
    isSuccess: successPasswordReset,
    isError: errorPasswordReset,
    reset: resetPasswordStatus,
    data: dataMessage,
  } = passwordResetStatus;

  const { isSuccess: accessSuccess, isError: accessError, reset: resetAccess, data: dataAccess } = blockingResult;

  const resetPassword = (value: number) => {
    resetPasswordTrigger(value);
  };
  // TODO: убрать эту чушь, заменить на один запрос с телом по ситуации за счёт присваивания свойствам тела undefined
  const searchWithOptions = () => {
    if (storeEmployees?.divisionId && storeEmployees?.search && !storeEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeEmployees.divisionId,
        search: storeEmployees.search,
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (!storeEmployees?.divisionId && storeEmployees?.search && !storeEmployees.personnelNumber) {
      getEmployees({
        search: storeEmployees.search,
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (storeEmployees?.divisionId && !storeEmployees?.search && !storeEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeEmployees.divisionId,
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (!storeEmployees?.divisionId && !storeEmployees?.search && storeEmployees.personnelNumber) {
      getEmployees({
        personnelNumber: storeEmployees.personnelNumber,
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (storeEmployees?.divisionId && !storeEmployees?.search && storeEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeEmployees.divisionId,
        personnelNumber: storeEmployees.personnelNumber,
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (!storeEmployees?.divisionId && !storeEmployees?.search && !storeEmployees.personnelNumber) {
      getEmployees({
        isActive: true,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }
  };

  const blockingEmployee = async (value: number) => {
    await blockingTrigger({ employeeId: Number(value), blockingId: 3 });
    // searchWithOptions();

    const body = {
      divisionId: storeEmployees.divisionId ? storeEmployees.divisionId : undefined,
      search: storeEmployees.search ? storeEmployees.search : undefined,
      isActive: true,
      page: currentPage,
      size: currentSize,
      allAvailableOrganizations,
      organizationId: currentOrganizationid,
    };
    await getEmployees(body);
  };

  const columns: ColumnsType<DataEmployees> = [
    {
      title: 'id',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Табельный номер',
      dataIndex: 'personnelNumber',
      key: 'personnelNumber',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Временный пароль',
      dataIndex: 'temporaryPassword',
      key: 'temporaryPassword',
    },
    {
      title: 'Действие',
      dataIndex: 'action',
      key: 'action',
      render: (_, record: { key: React.Key; temporaryPassword: string | null }) => (
        <div className={style.controlsBtnGroup} onClick={e => e.stopPropagation()}>
          <Popconfirm title="Вы уверены?" placement="leftTop" onConfirm={() => resetPassword(Number(record.key))}>
            <Button danger>Сбросить пароль</Button>
          </Popconfirm>
          {role === RolesUser.HRDirector && (
            <Popconfirm placement="leftTop" title="Вы уверены?" onConfirm={() => blockingEmployee(Number(record.key))}>
              <Button danger>Заблокировать</Button>
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  const onSearch = (value: string) => {
    if (optionsSearch === 'search') {
      dispatch(uiModel.Employees.actions.search(value));
      dispatch(uiModel.Employees.actions.personnelNumber(''));
      setCurrentPage(1);
    } else {
      dispatch(uiModel.Employees.actions.search(''));
      dispatch(uiModel.Employees.actions.personnelNumber(value));
      setCurrentPage(1);
    }
  };

  const onClear = () => {
    dispatch(uiModel.Employees.actions.divisionId(''));
    setCurrentPage(1);
  };

  const onSelectDivisionId = (id: string) => {
    dispatch(uiModel.Employees.actions.divisionId(id));
    dispatch(uiModel.Employees.actions.search(''));
    dispatch(uiModel.Employees.actions.personnelNumber(''));
    setCurrentPage(1);
  };

  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  const onSelectOptionsSearch = (value: string) => {
    setOptionsSearch(value);
  };

  useEffect(() => {
    searchWithOptions();
  }, [storeEmployees?.divisionId, storeEmployees?.search, storeEmployees?.personnelNumber, currentSize, currentPage]);

  // useEffect(() => {
  //   const paginationInfo = data?.pagination;
  //   if (dataReferences?.length === 0 && paginationInfo && currentPage !== 1) {
  //     // определяю текущую страницу
  //     const totalPages = Math.ceil(paginationInfo.total / paginationInfo.size);
  //     //  устанавливает текущую страницу на минимальное значение из текущей страницы и общего количества страниц,
  //     //  чтобы избежать установки текущей страницы на значение, превышающее общее количество страниц.
  //     setCurrentPage(Math.min(currentPage, totalPages));
  //   }
  // }, [dataReferences, data]);

  useEffect(() => {
    if (divisions) {
      setAllDivisions(divisions);
    }
  }, [divisions]);

  useEffect(() => {
    if (result?.data) {
      const dataSource = dataTableForEmployees(result?.data?.data);
      setEmployees(dataSource);
      setTotalPage(result.data.pagination.total);
    }
  }, [result?.data]);

  useEffect(() => {
    if (successPasswordReset) {
      notification.success({
        message: 'Пароль сброшен',
      });
    }
    resetPasswordStatus();
  }, [successPasswordReset]);

  useEffect(() => {
    if (errorPasswordReset) {
      notification.error({
        message: dataMessage,
      });
    }
    resetPasswordStatus();
  }, [errorPasswordReset, dataMessage]);

  useEffect(() => {
    if (accessSuccess) {
      notification.success({
        message: 'Пользователь заблокирован',
      });
    }
    resetAccess();
  }, [accessSuccess]);

  useEffect(() => {
    if (accessError) {
      notification.error({
        message: dataAccess,
      });
    }
    resetAccess();
  }, [accessError, dataAccess]);

  useEffect(
    () => () => {
      resetPasswordStatus();
      resetAccess();
    },
    [resetPasswordStatus, resetAccess, dispatch],
  );

  useEffect(() => {
    if (storeEmployees?.divisionId !== '') {
      form.setFields([
        {
          name: 'divisionId',
          value: storeEmployees?.divisionId,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'divisionId',
          value: undefined,
        },
      ]);
    }

    if (storeEmployees?.search !== '') {
      form.setFields([
        {
          name: 'search',
          value: storeEmployees?.search,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'search',
          value: undefined,
        },
      ]);
    }

    if (storeEmployees?.personnelNumber !== '') {
      form.setFields([
        {
          name: 'personnelNumber',
          value: storeEmployees?.personnelNumber,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'personnelNumber',
          value: undefined,
        },
      ]);
    }
  }, [storeEmployees?.divisionId, storeEmployees?.search, storeEmployees?.personnelNumber]);

  useEffect(() => {
    dispatch(uiModel.Employees.actions.divisionId(''));
    dispatch(uiModel.Employees.actions.search(''));
    dispatch(uiModel.Employees.actions.personnelNumber(''));
  }, [dispatch, allDivisions]);

  useEffect(() => {
    getEmployees({
      isActive: true,
      page: 1,
      size: 10,
      allAvailableOrganizations,
      organizationId: currentOrganizationid,
    });
  }, []);

  // сбрасываю значение фильтра и номер страницы при смене организации
  useEffect(() => {
    form.setFields([
      {
        name: 'selectOptions',
        value: 'search',
      },
    ]);
    setOptionsSearch('search');
    setCurrentPage(1);
  }, [currentOrganizationid]);

  useScrollUpPage(currentPage);

  return (
    <>
      <Form form={form} className={style.searchWrap} initialValues={initialValues}>
        {allDivisions && (
          <Form.Item name="divisionId">
            <Select
              placeholder="Выберите из списка"
              className={style.selectDivisions}
              onSelect={onSelectDivisionId}
              allowClear={true}
              onClear={onClear}
            >
              {allDivisions?.data?.map(({ id, name }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item name="selectOptions">
          <Select placeholder="Параметры поиска" className={style.selectDivisions} onSelect={onSelectOptionsSearch}>
            <Select.Option key="search" value="search">
              Поиск по ФИО
            </Select.Option>
            <Select.Option key="personnelNumber" value="personnelNumber">
              Поиск по табельному №
            </Select.Option>
          </Select>
        </Form.Item>

        {optionsSearch === 'search' ? (
          <Form.Item name="search" className={style.searchInput}>
            <Search placeholder="Поиск сотрудника по ФИО" allowClear onSearch={onSearch} />
          </Form.Item>
        ) : (
          <Form.Item
            name="personnelNumber"
            className={style.searchInput}
            normalize={value => value.replace(/[^0-9]/g, '')}
          >
            <Search placeholder="Поиск сотрудника по табельному №" allowClear onSearch={onSearch} maxLength={8} />
          </Form.Item>
        )}
      </Form>
      <AddEmployeeModal isModalOpen={isEditingModalOpen} setIsModalOpen={setIsEditingModalOpen} />
      <Spin spinning={result?.isLoading || result?.isFetching}>
        <div className={style.tableWrap}>
          <Table scroll={{ x: true }} dataSource={employees} columns={columns} pagination={false} />
          <div className={style.paginationWrap}>
            <Pagination
              showSizeChanger
              defaultCurrent={currentSize}
              current={currentPage}
              pageSize={currentSize}
              total={totalPage}
              onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
            />
          </div>
        </div>
      </Spin>
    </>
  );
};

export default Employees;
